import { h } from 'preact'
import { isTouchDevice, tagParser, linkParser, proxymedia } from '../../js/modules/utilities.js'
import { useState, useEffect } from 'preact/hooks'
import style from './shadowStyles_banniere.scss'

export const banniereStyle = style

export const bannierePlaceholder = `
   #postCommande.placeholder,
   #monAutreBannier.placeholder {
      min-height: 355px;
      @media (max-width: 960px) {
         min-height: 423px;
      }
      @media (max-width: 479px) {
         min-height: calc((100vw * (520 / 480)) + 30px);
      }
   }
`

export const Banniere = ({ format, tag, date, title, description, legals, legalNotice, images, URL, textColor, analytics, cacheKey, alt, index }) => {
   title = tagParser(title)
   description = tagParser(description)
   legals = tagParser(legals)
   let adviseTags = {}
   if (analytics.pdbSc === 'adv') {
      adviseTags = {
         'data-pdb-ta': analytics.pdbTa,
         'data-adv-canal': analytics.advCanal,
         'data-adv-cappingdata': analytics.advCappingdata,
      }
   }

   return (
      <div class={`banner-wrapper position-relative format-${format}`}>
         <a
            href={URL}
            class={`small-height banniere textcolor-${textColor}`}
            data-testid="banner"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            {...adviseTags}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
            data-cache-key={cacheKey}
         >
            <BackgroundImage format={format} images={images} alt={alt} />
            {(tag || date || title || description || legals) && <Content tag={tag} date={date} title={title} description={description} legals={legals} />}
         </a>
         {(legalNotice.content || legalNotice.title) && <LegalNotice {...legalNotice} index={index} />}
      </div>
   )
}

const getTagBgColor = (tag) => {
   if (tag && tag.indexOf('[tagwhite]') !== -1) {
      return 'white'
   } else {
      return 'yellow'
   }
}

const getTagText = (tag) => {
   if (tag) {
      tag = tag.replace(/\[.*?\]/g, '')
      return tag
   } else {
      return ''
   }
}

const Content = ({ tag, date, title, description, legals }) => {
   return (
      <div class="wrapper">
         <div class="content">
            {(tag || date) && (
               <div class="top">
                  {tag && <span class={`ob1-tag ${getTagBgColor(tag) === 'white' ? 'ob1-tag-white' : 'ob1-tag-primary'}`}>{getTagText(tag)}</span>}
                  {date && <span class="date">{date}</span>}
               </div>
            )}
            {title && <h3 class="title" dangerouslySetInnerHTML={{ __html: title }}></h3>}
            {description && <p class="description" dangerouslySetInnerHTML={{ __html: description }}></p>}

            {legals && (
               <div class="bottom">
                  <p class="legals" dangerouslySetInnerHTML={{ __html: legals }}></p>
               </div>
            )}
         </div>
      </div>
   )
}

const LegalNotice = ({ showButtonLabel, title, content, background, index = 0 }) => {
   const [legalState, setLegalState] = useState(false)
   const [legalHoverState, setLegalHoverState] = useState(false)

   const toggleLegals = () => {
      setLegalState(!legalState)
      if (legalState === false) {
         pauseCarrousel()
      } else {
         resetCarrousel()
      }
   }

   const closeLegals = () => {
      if (legalState) {
         setLegalState(false)
         resetCarrousel()
      }
   }

   // Ajouter l'écoute de la touche Escape
   useEffect(() => {
      const handleKeyDown = (event) => {
         if (event.key === 'Escape') {
            closeLegals()
         }
      }

      if (legalState) {
         document.addEventListener('keydown', handleKeyDown)
      }

      return () => {
         document.removeEventListener('keydown', handleKeyDown)
      }
   }, [legalState])

   const showLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(true)
   }

   const hideLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(false)
   }

   const pauseCarrousel = () => {
      const isCarrouselPlaying = document.querySelector('.glide__playpause--pause') ? true : false
      if (isCarrouselPlaying) {
         document.querySelector('.glide__playpause').classList.add('pauseByLegals')
         document.querySelector('.glide__playpause').click()
      }
   }

   const resetCarrousel = () => {
      const isCarrouselPause = document.querySelector('.glide__playpause--play') ? true : false
      if (isCarrouselPause) {
         let isCarrouselPausedByLegal = document.querySelector('.glide__playpause.pauseByLegals') ? true : false
         if (isCarrouselPausedByLegal) {
            document.querySelector('.glide__playpause').click()
            document.querySelector('.glide__playpause').classList.remove('pauseByLegals')
         }
      }
   }

   return (
      <div
         class={`bannerLegalNotice ${legalState ? 'openContent' : ''} ${legalHoverState ? 'isHover' : ''} ${background === 'white' ? 'grey-bg' : 'black-bg'}`}
         onMouseLeave={hideLegals}
      >
         <div id={`legalNoticePanel${index}`} class="contentLegalNotice" aria-hidden={!legalState}>
            <span class="closeLegal" onClick={toggleLegals}>
               &times;
            </span>
            <div class="contentText">
               {title && <div class="legalNoticeTitle" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></div>}
               {content && <div dangerouslySetInnerHTML={{ __html: tagParser(linkParser(content)) }}></div>}
            </div>
         </div>
         <span
            class="showButton"
            onClick={toggleLegals}
            onMouseEnter={showLegals}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls={`legalNoticePanel${index}`}
         >
            <span class="showButton-label">{showButtonLabel}</span>&nbsp;
            <span class="icon-showButton">
               <svg viewBox="0 0 32 32">
                  <path d="M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16-16-7.164-16-16 7.164-16 16-16zM17.687 11.693h-3.358v11.346c0.138 0.719 0.83 1.268 1.669 1.268s1.552-0.548 1.689-1.268v-11.346zM16 5.991c-0.502 0-0.957 0.205-1.286 0.535l-0 0c-0.329 0.331-0.532 0.786-0.532 1.29 0 0 0 0.001 0 0.001v-0c-0 0.009-0 0.020-0 0.031 0 0.667 0.358 1.251 0.892 1.569l0.008 0.005c0.263 0.157 0.579 0.25 0.918 0.25s0.655-0.093 0.926-0.254l-0.008 0.005c0.543-0.323 0.9-0.907 0.9-1.574 0-0.011-0-0.022-0-0.033l0 0.002c0-1.008-0.814-1.825-1.818-1.826z"></path>
               </svg>
            </span>
         </span>
      </div>
   )
}

const BackgroundImage = ({ format, images, alt }) => {
   // small: 960x1040
   // medium: 1800x720
   // large: 1440x310
   let balisePicture = (
      <picture>
         <source srcset={`${proxymedia(images.small, 'saveas=webp')}`} media="(max-width: 479px)" />
         <source srcset={`${proxymedia(images.medium, 'saveas=webp')}`} media="(max-width: 959px)" />
         <img class="background-img" src={proxymedia(images.large, 'saveas=webp')} alt={alt} />
      </picture>
   )

   // N-1 TV
   // small: 960x1040
   // medium: 1800x720
   // large: 1200x388
   if (format === '1200x388-960x1040') {
      balisePicture = (
         <picture>
            <source srcset={`${proxymedia(images.small, 'saveas=webp')}`} media="(max-width: 479px)" />
            <source srcset={`${proxymedia(images.medium, 'saveas=webp')}`} media="(max-width: 959px)" />
            <img class="background-img" src={`${proxymedia(images.large, 'crop=960,310,0,39&saveas=webp')}`} alt={alt} />
         </picture>
      )
   }

   return balisePicture
}
